/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Nexus Imports
 */
import { NeuChip, NeuTag } from '@neutron/react';

export const BlueChip: FC<{
  icon?: string | undefined;
  name: string;
  removable?: boolean | undefined;
}> = ({ name, removable = true, icon }) => {
  return removable ? (
    <NeuChip
      id={`Blue-Chip-${name}`}
      color="blue"
      icon={icon !== ' ' ? icon || 'person' : undefined}
      kind="removable"
      className={`mx-1 mt-1 py-3 ${icon === ' ' ? ' ps-2 ' : ''}`}
    >
      {name}
    </NeuChip>
  ) : (
    <NeuTag
      id={`Blue-Tag-${name}`}
      color="blue"
      icon={icon !== ' ' ? icon || 'person' : undefined}
      className={`mx-1 mt-1 py-3 ${icon === ' ' ? ' ps-2 ' : ''}`}
    >
      {name}
    </NeuTag>
  );
};
